// import { BrowserRouter as Router } from "react-router-dom";
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import router from './routes/index';
import ModalRenderer from './components/common/ModalRenderer';
import PageLoadingFallback from './components/common/PageLoadingFallback';

function App() {
  return (
    <>
      <Suspense
        fallback={
          <PageLoadingFallback className="flex min-h-screen items-center justify-center bg-indigo-50 p-6" />
        }
      >
        <RouterProvider router={router} />
      </Suspense>
      <ModalRenderer />
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{
          zIndex: 99999, // Higher z-index to appear above modals
        }}
        toastOptions={{
          // Default options for all toasts
          className: '',
          duration: 4000,
          style: {
            background: '#ffffff',
            color: '#374151',
            fontSize: '14px',
            fontWeight: '500',
            borderRadius: '0.75rem',
            boxShadow:
              '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e5e7eb',
            padding: '12px 16px',
            maxWidth: '400px',
            zIndex: 99999, // Ensure individual toasts also have high z-index
          },
          // Default options for specific types
          success: {
            duration: 4000,
            iconTheme: {
              primary: '#16a34a',
              secondary: '#f0fdf4',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#dc2626',
              secondary: '#fef2f2',
            },
          },
          loading: {
            iconTheme: {
              primary: '#6366f1',
              secondary: '#f8fafc',
            },
          },
        }}
      />
    </>
  );
}

export default App;
